import { applyService } from "@/service"
import ActionId from "@/action/ActionId"
import { goto } from "@/util/navigation"
import Action from "@/action/Action"

class HFDSubmitBankCardAction extends Action {
    providerKey = null
    request = null
    path = null

    constructor(providerKey, request, path) {
        super(ActionId.SUBMIT_BANK_CARD, providerKey)
        this.providerKey = providerKey
        this.request = request
        this.path = path
    }

    async invoke() {
        const response = await applyService.addBankCard(this.providerKey, this.request)
        return await this.handleResponse(response)
    }

    async handleResponse(response) {
        if (response.responseCode === 'error' && response.errors) {
            return response
        } else if (response.responseCode === 'error') {
            await goto({ path: `/providers/${this.providerKey}/error` })
        } else {
            await goto({ path: `/providers/${this.providerKey}/${this.path}` })
        }
    }

}

export default HFDSubmitBankCardAction
